export interface FilterCondition {
  id: string;
  name: string;
}